import { Text } from "@/components/ui/baseUi/text"
import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import { TemplateButtons } from "@/modules/template/components/sidebarImport/templateButtons"
import {
  TemplateWeekImportModal,
  type TemplateWeekImportModalRef,
} from "@/modules/template/components/sidebarImport/templateWeekImportModal"
import { TemplateWrapper } from "@/modules/template/components/sidebarImport/templateWrapper"
import { useTemplateImportSelectedTemplate } from "@/modules/template/stores/useTemplateImportStore"
import { TemplateType } from "@/modules/template/types/templateType"
import { Suspense, useRef } from "react"

type TemplateImportWeekViewProps = {
  programId: string
  options: {
    startDate: Date | null
    startIndex: number | null
  }
  className?: string
} & React.ComponentProps<"div">

export function TemplateImportWeekView({ programId, options, className, ...props }: TemplateImportWeekViewProps) {
  const selectedTemplate = useTemplateImportSelectedTemplate()
  const modalRef = useRef<TemplateWeekImportModalRef>(null)

  const handleValidateWeekTemplate = () => {
    void modalRef.current?.onImportTemplateClick()
  }

  return (
    <>
      <div className={cn("flex flex-1 flex-col gap-4 pt-18", className)} {...props}>
        <div className="flex flex-1 grow flex-col gap-8">
          <Text fontStyle="TL" className="px-6">
            {word("templateType.import.title.week")}
          </Text>
          <TemplateWrapper templateType={TemplateType.WEEK} />
        </div>

        <Suspense
          fallback={
            <TemplateButtons
              className="sticky bottom-0 flex flex-row gap-2 bg-surface-background-default px-6 pt-4 pb-2"
              onValidate={() => {
                /* Empty */
              }}
              isLoading={true}
            />
          }
        >
          {selectedTemplate ? (
            <TemplateWeekImportModal
              ref={modalRef}
              programId={programId}
              templateId={selectedTemplate.id}
              options={options}
            />
          ) : null}

          <TemplateButtons
            className="sticky bottom-0 flex flex-row gap-2 bg-surface-background-default px-6 pt-4 pb-2"
            onValidate={() => {
              handleValidateWeekTemplate()
            }}
          />
        </Suspense>
      </div>
    </>
  )
}
